import { MenuTranslation } from '@/assets/locales/menu/menu.translation.en.ts';
import { PolishPlurals } from '@/assets/locales/PolishPlurals.model.ts';

export const menuTranslation: PolishPlurals<MenuTranslation> = {
  items: {
    ATTEMPTS: 'Podejścia',
    DASHBOARD: 'Dashboard',
    DEV_PATTERNS: 'Wzorce interfejsu',
    DICTIONARIES: 'Słowniki',
    PATHS: 'Ścieżki',
    PROCESSES: 'Procesy',
    QUESTION_BANK: 'Baza pytań',
    QUESTION_STATISTICS: 'Skuteczność pytań',
    SETTINGS: 'Ustawienia',
    SURVEYS: 'Ankiety',
    TESTS: 'Testy',
  },
  sections: {
    DEVELOPER: 'Deweloper',
    MODULES: 'Moduły',
    OVERVIEW: 'Przegląd',
    SYSTEM: 'System',
  },
};
